import { render, staticRenderFns } from "./MonitorOff.vue?vue&type=template&id=1ccf39a5"
import script from "./MonitorOff.vue?vue&type=script&lang=js"
export * from "./MonitorOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports